const scrollingNavigate = (id) => {
  const offset = 83;
  const element = document.getElementById(id);
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
  // window.history.pushState({}, null, newUrl);
};

module.exports.onRouteUpdate = ({ location, prevLocation }) => {
  window.history.scrollRestoration = 'manual';
  // console.log(pageData.location.href);
  const sectionId = location.href.split('#')[1];
  if (sectionId) {
    if (prevLocation) {
      scrollingNavigate(sectionId);
    } else
      setTimeout(() => {
        scrollingNavigate(sectionId);
      }, 125);
  } else {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
};

module.exports.shouldUpdateScroll = () => {
  return false;
};

module.exports.onInitialClientRender = () => {
  window.history.scrollRestoration = 'manual';
};
